import { render, staticRenderFns } from "./index.vue?vue&type=template&id=745f01ce&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745f01ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('745f01ce')) {
      api.createRecord('745f01ce', component.options)
    } else {
      api.reload('745f01ce', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=745f01ce&scoped=true", function () {
      api.rerender('745f01ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scenic-spot/category/index.vue"
export default component.exports